var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-checkbox" },
    [
      _c(
        "label",
        {
          staticClass: "v-checkbox__item",
          class: { "v-checkbox__item--disabled": _vm.isDisabled },
          attrs: { name: _vm.name, "data-name": _vm._name },
          on: { click: _vm.clickCheckbox },
        },
        [
          _c("span", {
            staticClass: "v-checkbox__icon",
            class:
              _vm.value === _vm.onValue
                ? "v-checkbox__icon--active v-icon-ok"
                : _vm.hasValue
                ? "v-checkbox__icon--active v-icon-minus-square"
                : "v-icon-check",
          }),
          _c(
            "span",
            { staticClass: "v-checkbox__label" },
            [_vm._t("default")],
            2
          ),
        ]
      ),
      _vm._t("content"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }